import React, { useCallback } from 'react';
import S from './PlanningVue.module.scss';
import { Mode } from './types';

interface PlanningVueControlsProps {
  defaultModes: Mode[];
  selectedMode: Mode | undefined;
  currentInteractionMode: string;
  setSelectedMode: (mode: Mode) => void;
  setCurrentInteractionMode: (mode: string) => void;
  toggleMarkerMode: () => void;
  toggleRemoveMode: () => void;
  toggleCopyMode: () => void;
}

const PlanningVueControls: React.FC<PlanningVueControlsProps> = ({
  defaultModes,
  selectedMode,
  currentInteractionMode,
  setSelectedMode,
  setCurrentInteractionMode,
  toggleMarkerMode,
  toggleRemoveMode,
  toggleCopyMode,
}) => {
  return (
    <div className={S.topControlsRow}>
      {/* Colonne 1: Sélection du mode */}
      <div className={S.modeSelectorContainer}>
        <label>Sélectionner un mode :</label>
        <div className={S.modeButtonsGroup}>
          {defaultModes.length > 0 ? (
            defaultModes.map((mode) => (
              <button
                key={mode.id}
                className={`${S.modeButton} ${
                  selectedMode?.id === mode.id ? S.active : ''
                }`}
                style={{
                  backgroundColor:
                    selectedMode?.id === mode.id
                      ? mode.color
                      : `${mode.color}20`,
                  color: selectedMode?.id === mode.id ? 'white' : mode.color,
                  borderColor: mode.color,
                  fontWeight: selectedMode?.id === mode.id ? 600 : 500,
                }}
                onClick={() => {
                  setSelectedMode(mode);
                  setCurrentInteractionMode('color');
                }}
              >
                {mode.name}
              </button>
            ))
          ) : (
            <>
              <button className={S.modeButton}>Ouvert</button>
              <button className={S.modeButton}>Fermé</button>
            </>
          )}
        </div>
      </div>

      {/* Colonne 2: Ajouter/Supprimer jalons */}
      <div className={S.jalonsControls}>
        <label>Ajouter / Supprimer des jalons :</label>
        <div className={S.jalonsButtonsGroup}>
          <button
            className={`${S.jalonButton} ${
              currentInteractionMode === 'add-marker' ? S.active : ''
            }`}
            onClick={toggleMarkerMode}
            title="Ajouter des jalons"
          >
            <span className={S.jalonButtonIconPlus}>+</span>
          </button>
          <button
            className={`${S.jalonButton} ${
              currentInteractionMode === 'remove-marker' ? S.active : ''
            }`}
            onClick={toggleRemoveMode}
            title="Supprimer des jalons"
          >
            <span className={S.jalonButtonIconMois}>-</span>
          </button>
        </div>
      </div>

      {/* Colonne 3: Copier sélection */}
      <button
        className={`${S.copyButton} ${
          currentInteractionMode === 'copy-day' ? S.active : ''
        }`}
        onClick={toggleCopyMode}
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
        </svg>
        Copier sélection
      </button>
    </div>
  );
};

export default PlanningVueControls;
